var _dec, _class, _TopNavBarBrand;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import { Component } from 'react';
import { getElementType, omitProps } from '@instructure/ui-react-utils';
import { withStyle } from '@instructure/emotion';
import { ScreenReaderContent } from '@instructure/ui-a11y-content';
import { View } from '@instructure/ui-view';
import { TopNavBarContext } from "../TopNavBarContext.js";
import generateStyle from "./styles.js";
import generateComponentTheme from "./theme.js";
import { allowedProps } from "./props.js";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
/**
---
parent: TopNavBar
id: TopNavBar.Brand
---
@module TopNavBarBrand
**/
let TopNavBarBrand = (_dec = withStyle(generateStyle, generateComponentTheme), _dec(_class = (_TopNavBarBrand = class TopNavBarBrand extends Component {
  constructor(...args) {
    super(...args);
    this.ref = null;
    this.handleRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
  }
  componentDidMount() {
    var _this$props$makeStyle, _this$props;
    // TODO: Remove this in v10!
    if ('renderName' in this.props) {}

    // TODO: Remove this in v10!
    if ('nameBackground' in this.props) {}
    (_this$props$makeStyle = (_this$props = this.props).makeStyles) === null || _this$props$makeStyle === void 0 ? void 0 : _this$props$makeStyle.call(_this$props, this.makeStylesVariables);
  }
  componentDidUpdate() {
    var _this$props$makeStyle2, _this$props2;
    (_this$props$makeStyle2 = (_this$props2 = this.props).makeStyles) === null || _this$props$makeStyle2 === void 0 ? void 0 : _this$props$makeStyle2.call(_this$props2, this.makeStylesVariables);
  }
  get makeStylesVariables() {
    return {
      layout: this.context.layout
    };
  }
  render() {
    const _this$props3 = this.props,
      screenReaderLabel = _this$props3.screenReaderLabel,
      renderIcon = _this$props3.renderIcon,
      href = _this$props3.href,
      onClick = _this$props3.onClick,
      styles = _this$props3.styles;
    const ElementType = getElementType(TopNavBarBrand, this.props);
    return _jsx("div", {
      ref: this.handleRef,
      css: styles === null || styles === void 0 ? void 0 : styles.topNavBarBrand,
      "data-cid": "TopNavBarBrand",
      children: renderIcon && _jsxs(View, {
        ...omitProps(this.props, allowedProps),
        css: styles === null || styles === void 0 ? void 0 : styles.container,
        as: ElementType,
        href: href,
        onClick: onClick,
        position: "relative",
        focusColor: this.context.inverseColor ? 'info' : 'inverse',
        focusPosition: "inset",
        borderRadius: "medium",
        themeOverride: {
          focusOutlineInset: styles === null || styles === void 0 ? void 0 : styles.focusOutlineInset
        },
        children: [_jsx(ScreenReaderContent, {
          children: screenReaderLabel
        }), renderIcon && this.context.layout !== 'smallViewport' && _jsx("div", {
          css: styles === null || styles === void 0 ? void 0 : styles.iconContainer,
          role: "presentation",
          "aria-hidden": "true",
          children: renderIcon
        })]
      })
    });
  }
}, _TopNavBarBrand.displayName = "TopNavBarBrand", _TopNavBarBrand.componentId = 'TopNavBar.Brand', _TopNavBarBrand.allowedProps = allowedProps, _TopNavBarBrand.defaultProps = {}, _TopNavBarBrand.contextType = TopNavBarContext, _TopNavBarBrand)) || _class);
export { TopNavBarBrand };
export default TopNavBarBrand;